<!--
 * @Author: your name
 * @Date: 2020-10-23 09:30:49
 * @LastEditTime: 2021-05-28 10:27:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zhihui\roses-admin-vue\src\App.vue
-->
<template>
  <div id="app" :style="isH5Page ? h5Style : {}">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  computed: {
    isH5Page() {
      return (
        this.$route.name == 'AppList' ||
        this.$route.name == 'AppDownloadPage' ||
        this.$route.name == 'Protocol'
      );
    }
  },
  data() {
    return {
      h5Style: {
        width: '100vm',
        height: '100vh',
        backgroundColor: '#f4f4f4',
        minWidth: '320px',
        minHeight: '568px'
      }
    };
  }
};
</script>

<style lang="less">
@import url('//at.alicdn.com/t/font_2049201_m3dg2o7dusm.css');

html,
body {
  height: 100%;
}
#app {
  min-width: 1280px;
  min-height: 720px;
  height: 100%;
  // overflow: auto;
}
.area-tree .el-radio__inner {
  top: -18px;
  left: -19px;
  border-radius: 0;
  border: 0;
  width: 170px;
  height: 34px;
  background-color: transparent;
  cursor: pointer;
  box-sizing: border-box;
  position: absolute;
}

.area-tree .el-radio__input.is-checked .el-radio__inner {
  background: transparent;
}
</style>
